/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/


import { createApp } from 'vue'







import '@quasar/extras/ionicons-v4/ionicons-v4.css'

import '@quasar/extras/roboto-font/roboto-font.css'

import '@quasar/extras/material-icons/material-icons.css'



import '@quasar/extras/animate/fadeIn.css'

import '@quasar/extras/animate/fadeOut.css'

import '@quasar/extras/animate/fadeOutUp.css'

import '@quasar/extras/animate/fadeInUp.css'

import '@quasar/extras/animate/fadeInDown.css'

import '@quasar/extras/animate/fadeOutDown.css'

import '@quasar/extras/animate/fadeInRight.css'

import '@quasar/extras/animate/fadeOutRight.css'

import '@quasar/extras/animate/bounceIn.css'

import '@quasar/extras/animate/slideInUp.css'

import '@quasar/extras/animate/slideOutDown.css'

import '@quasar/extras/animate/slideInDown.css'

import '@quasar/extras/animate/slideOutUp.css'


// We load Quasar stylesheet file
import 'quasar/dist/quasar.sass'




import 'src/css/app.sass'

import 'src/css/internal-documentation.sass'

import 'src/css/custom-pages.sass'

import 'src/css/swiper.sass'

import '@quasar/quasar-ui-qiconpicker/src/index.sass'


import createQuasarApp from './app.js'
import quasarUserOptions from './quasar-user-options.js'







const publicPath = `/`


async function start ({
  app,
  router
  , store, storeKey
}, bootFiles) {
  

  
  let hasRedirected = false
  const getRedirectUrl = url => {
    try { return router.resolve(url).href }
    catch (err) {}

    return Object(url) === url
      ? null
      : url
  }
  const redirect = url => {
    hasRedirected = true

    if (typeof url === 'string' && /^https?:\/\//.test(url)) {
      window.location.href = url
      return
    }

    const href = getRedirectUrl(url)

    // continue if we didn't fail to resolve the url
    if (href !== null) {
      window.location.href = href
      
    }
  }

  const urlPath = window.location.href.replace(window.location.origin, '')

  for (let i = 0; hasRedirected === false && i < bootFiles.length; i++) {
    try {
      await bootFiles[i]({
        app,
        router,
        store,
        ssrContext: null,
        redirect,
        urlPath,
        publicPath
      })
    }
    catch (err) {
      if (err && err.url) {
        redirect(err.url)
        return
      }

      console.error('[Quasar] boot error:', err)
      return
    }
  }

  if (hasRedirected === true) {
    return
  }
  

  app.use(router)
  app.use(store, storeKey)

  

    

    
      app.mount('#q-app')
    

    

  

}

createQuasarApp(createApp, quasarUserOptions)

  .then(app => {
    // eventually remove this when Cordova/Capacitor/Electron support becomes old
    const [ method, mapFn ] = Promise.allSettled !== void 0
      ? [
        'allSettled',
        bootFiles => bootFiles.map(result => {
          if (result.status === 'rejected') {
            console.error('[Quasar] boot error:', result.reason)
            return
          }
          return result.value.default
        })
      ]
      : [
        'all',
        bootFiles => bootFiles.map(entry => entry.default)
      ]

    return Promise[ method ]([
      
      import(/* webpackMode: "eager" */ 'boot/rollbar'),
      
      import(/* webpackMode: "eager" */ 'boot/expose-app'),
      
      import(/* webpackMode: "eager" */ 'boot/local-db'),
      
      import(/* webpackMode: "eager" */ 'boot/vue-layout-count-tracker'),
      
      import(/* webpackMode: "eager" */ 'boot/core-js'),
      
      import(/* webpackMode: "eager" */ 'boot/lodash'),
      
      import(/* webpackMode: "eager" */ 'boot/smooth-scroll'),
      
      import(/* webpackMode: "eager" */ 'boot/dragscroll'),
      
      import(/* webpackMode: "eager" */ 'boot/apollo'),
      
      import(/* webpackMode: "eager" */ 'boot/remote-commands'),
      
      import(/* webpackMode: "eager" */ 'boot/print-transactions'),
      
      import(/* webpackMode: "eager" */ 'boot/direct-upload'),
      
      import(/* webpackMode: "eager" */ 'boot/card-handler'),
      
      import(/* webpackMode: "eager" */ 'boot/print-handler'),
      
      import(/* webpackMode: "eager" */ 'boot/electron-input-scanner'),
      
      import(/* webpackMode: "eager" */ 'boot/payment-connector-handler'),
      
      import(/* webpackMode: "eager" */ 'boot/payments'),
      
      import(/* webpackMode: "eager" */ 'boot/swiper'),
      
      import(/* webpackMode: "eager" */ 'boot/vue-country-flag'),
      
      import(/* webpackMode: "eager" */ 'boot/vue-pinch-scroll-zoom'),
      
      import(/* webpackMode: "eager" */ 'boot/rollbar-helper'),
      
      import(/* webpackMode: "eager" */ 'boot/constants'),
      
      import(/* webpackMode: "eager" */ 'boot/mh-helper'),
      
      import(/* webpackMode: "eager" */ 'boot/bus'),
      
      import(/* webpackMode: "eager" */ 'boot/sales-restrictions'),
      
      import(/* webpackMode: "eager" */ 'boot/hardware'),
      
      import(/* webpackMode: "eager" */ 'boot/customer-display-handler'),
      
      import(/* webpackMode: "eager" */ 'boot/model-form-lock'),
      
      import(/* webpackMode: "eager" */ 'boot/q-component-defaults'),
      
      import(/* webpackMode: "eager" */ 'boot/base-components'),
      
      import(/* webpackMode: "eager" */ 'boot/model-form-components'),
      
      import(/* webpackMode: "eager" */ 'boot/../models'),
      
      import(/* webpackMode: "eager" */ 'boot/../utils/ModelLeakDetector'),
      
      import(/* webpackMode: "eager" */ 'boot/../utils/VueLeakDetector'),
      
      import(/* webpackMode: "eager" */ 'boot/version-manager'),
      
      import(/* webpackMode: "eager" */ 'boot/i18n'),
      
      import(/* webpackMode: "eager" */ 'boot/../modules/auth'),
      
      import(/* webpackMode: "eager" */ 'boot/../modules/checkout'),
      
      import(/* webpackMode: "eager" */ 'boot/../modules/admin'),
      
      import(/* webpackMode: "eager" */ 'boot/../modules/register'),
      
      import(/* webpackMode: "eager" */ 'boot/../modules/kds'),
      
      import(/* webpackMode: "eager" */ 'boot/../modules/customer-display'),
      
      import(/* webpackMode: "eager" */ 'boot/../modules/signage'),
      
      import(/* webpackMode: "eager" */ 'boot/../modules/kiosk'),
      
      import(/* webpackMode: "eager" */ 'boot/../modules/roam'),
      
      import(/* webpackMode: "eager" */ 'boot/../modules/consumer/consumer-order'),
      
      import(/* webpackMode: "eager" */ 'boot/../modules/consumer'),
      
      import(/* webpackMode: "eager" */ 'boot/../modules/statics'),
      
      import(/* webpackMode: "eager" */ 'boot/highcharts'),
      
      import(/* webpackMode: "eager" */ 'boot/tracking/tracking'),
      
      import(/* webpackMode: "eager" */ 'boot/screen-share'),
      
      import(/* webpackMode: "eager" */ 'boot/console-stream'),
      
      import(/* webpackMode: "eager" */ 'boot/geoapify'),
      
      import(/* webpackMode: "eager" */ 'boot/capacitor-adapter'),
      
      import(/* webpackMode: "eager" */ '@quasar/quasar-app-extension-qiconpicker/src/boot/register.js')
      
    ]).then(bootFiles => {
      const boot = mapFn(bootFiles).filter(entry => typeof entry === 'function')
      start(app, boot)
    })
  })

